var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alertCondition)?_c('div',{staticClass:"alert-container"},[_c('svgicon',{staticClass:"info",attrs:{"name":"info"}}),_c('div',{staticClass:"alert-message"},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }